module.exports = __webpack_public_path__ + "img/link.c98d9961.svg";